import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(public)/success-stories/page.tsx");
